export default __webpack_public_path__ + "static/Reishi-green-41c72c113dc2c33132af935526b9bb0e.svg";